import { PlatformSection } from '@/common/components';
import { useNewTranslations } from '@/common/translations';
import { VictoryProbability } from '../../components';
import { usePrematchData } from '../../hooks';

export default function VictoryProbabilitySection() {
  const translate = useNewTranslations();
  const { teams, statistics } = usePrematchData();
  const sectionName = translate('PreMatchStats.VictoryProbability');

  if (!statistics?.victoryProbability) {
    return null;
  }

  const { home: homePercent, away: awayPercent } = statistics.victoryProbability;

  return (
    <PlatformSection contentClassName="py-1" name={sectionName}>
      <VictoryProbability
        homePercent={homePercent}
        awayPercent={awayPercent}
        homeName={teams.home.name}
        awayName={teams.away.name}
      />
    </PlatformSection>
  );
}
